module.exports = __webpack_public_path__ + "components/flag/static/square/mu-a8bc31a5bd5943f40fdf7e73a1d0efe2.svg";